import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Oct 31 2018
 * @author SKu
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { inject, observer } from 'mobx-react';
import * as React from 'react';
import Badge from '../../../components/info/Badge';
import Notice from '../../../components/info/Notice';
import Icon, { IconColor, IconType } from '../../../components/media/Icon';
import { StoreName } from '../../../shared/stores/StoreName';
import translate from '../../i18n/translate';
import { CONSTANTS } from '../../../constants';
import { Link } from 'react-router-dom';
import { getPath } from '../../i18n/translate';

var Notifications =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Notifications, _React$Component);

  function Notifications() {
    _classCallCheck(this, Notifications);

    return _possibleConstructorReturn(this, _getPrototypeOf(Notifications).apply(this, arguments));
  }

  _createClass(Notifications, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.notificationStore.startPolling();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.notificationStore.stopPolling();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var Renderer = this.props.renderer;
      return React.createElement(React.Fragment, null, React.createElement("div", {
        className: "header-icon header-dark header-notification relative"
      }, React.createElement(Icon, {
        className: "header-notification-icon",
        iconType: IconType.notification,
        iconHeight: 35,
        iconColor: IconColor.Inverse
      }), this.props.notificationStore.notificationsTotalCount > 0 ? React.createElement(React.Fragment, null, React.createElement(Badge, {
        className: "header-notification-badge"
      }, this.props.notificationStore.notificationsTotalCount), React.createElement("div", {
        className: "header-notification-menubox"
      }, React.createElement("div", {
        className: "header-notification-menu"
      }, Array.from(this.props.notificationStore.newNotifications).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            notification = _ref2[1];

        return React.createElement(Renderer, {
          key: key,
          onClose: function onClose() {
            return _this.props.notificationStore.remove([key]);
          },
          notification: notification
        });
      }), this.props.notificationStore.notificationsTotalCount > 10 && CONSTANTS.APP.NAME === 'promo' && React.createElement(Notice, {
        contentSizes: [12],
        content: [React.createElement(Link, {
          key: "notifications-show-more",
          to: getPath('PROMO-HOME-PATH')
        }, translate.apply(void 0, ['PROMO_NOTIFICATIONS_SHOW_MORE'].concat([(this.props.notificationStore.notificationsTotalCount - 10).toString()])))]
      })))) : React.createElement(React.Fragment, null, React.createElement("div", {
        className: "header-notification-menubox"
      }, React.createElement("div", {
        className: "header-notification-menu"
      }, React.createElement(Notice, {
        contentSizes: [12],
        content: [translate('header-notification-empty')]
      }))))));
    }
  }]);

  return Notifications;
}(React.Component);

Notifications = __decorate([inject(function (allStores) {
  return {
    notificationStore: allStores[StoreName.Notification]
  };
}), observer], Notifications);
export default Notifications;